import { Box } from '@chakra-ui/react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@mesh.ai/rabbit';
import { LabelFieldWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/LabelFieldWrapper';

import { EngagementDriverType } from '../../types';
import { EngagementQuestionType } from '../slice/AddEngagementQuestion.slice';

type Props = {
  tag: {
    uuid: string;
  };
  filteredDrivers: EngagementDriverType[];
  handleQuestionChange: (value: Partial<EngagementQuestionType>) => void;
};

const DriverDropdown = ({ tag, filteredDrivers, handleQuestionChange }: Props) => (
  <LabelFieldWrapper label="Driver" gridTemplateColumns="200px 1fr" gridGap={0}>
    <Select value={tag?.uuid} onValueChange={(value) => handleQuestionChange({ tag: { uuid: value } })}>
      <SelectTrigger style={{ width: '100%', textAlign: 'left' }}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent style={{ maxWidth: '100%', maxHeight: '300px' }}>
        <SelectGroup>
          {filteredDrivers?.map(({ id, displayName }) => (
            <Box
              key={id}
              sx={{
                '& span:nth-child(2)': {
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  maxWidth: '100%',
                  whiteSpace: 'nowrap',
                },
              }}
            >
              <SelectItem
                value={id}
                style={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  maxWidth: '360px',
                  whiteSpace: 'nowrap',
                }}
              >
                {displayName}
              </SelectItem>
            </Box>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  </LabelFieldWrapper>
);

export { DriverDropdown };
